import React, { useState } from 'react';
import { Button, Form, Col, Container, Row, Table, Card } from 'react-bootstrap';

function TargetCalculator() {
    const [overs, setOvers] = useState(20);
    const [fiScore, setFiScore] = useState();
    const [loading, setLoading] = useState(true);

    const [chWin20, setChWin20] = useState('');
    const [chWin18, setChWin18] = useState('');
    const [chWin17, setChWin17] = useState('');

    const [defWin20, setDefWin20] = useState('');
    const [defWin18, setDefWin18] = useState('');
    const [defWin17, setDefWin17] = useState('');

    const [chLoss4, setChLoss4] = useState('');
    const [chLoss2, setChLoss2] = useState('');
    const [chLoss1, setChLoss1] = useState('');

    const [defLoss4, setDefLoss4] = useState('');
    const [defLoss2, setDefLoss2] = useState('');
    const [defLoss1, setDefLoss1] = useState('');

    const getOvers = (type, overs) => {
        var fullOvers = parseInt(overs);
        var remainingBalls = (fullOvers == overs) ? 0 : (type === 'c' ? Math.floor(((overs - fullOvers) * 6).toFixed(2)) : Math.ceil(((overs - fullOvers) * 6).toFixed(2)))
        if (remainingBalls == 6) {
            return (fullOvers + 1);
        } else if (remainingBalls == 0) {
            return fullOvers;
        }
        return fullOvers + "." + remainingBalls;
    }

    const calculateTarget = () => {

        if (!overs || !fiScore || isNaN(overs) || isNaN(fiScore)) {
            setResult('Please enter valid values for overs and first inning score.');
            return;
        }
        var chWin20, chWin18, chWin17,
            defWin20, defWin18, defWin17,
            chLoss4, chLoss2, chLoss1,
            defLoss4, defLoss2, defLoss1;

        var team1Drr = fiScore / overs;

        chWin20 = getOvers('c', (fiScore + 1) / (team1Drr + 3));
        chWin18 = getOvers('c', (fiScore + 1) / (team1Drr + 2));
        chWin17 = getOvers('c', (fiScore + 1) / (team1Drr + 1));

        chLoss4 = Math.ceil(overs * (team1Drr - 0.25));
        chLoss2 = Math.ceil(overs * (team1Drr - 0.5));
        chLoss1 = Math.ceil(overs * (team1Drr - 0.75));

        chLoss4 = (chLoss4 > 0) ? chLoss4 : 0;
        chLoss2 = (chLoss2 > 0) ? chLoss2 : 0;
        chLoss1 = (chLoss1 > 0) ? chLoss1 : 0;

        defWin20 = (team1Drr < 3) ? 0 : Math.floor(overs * (team1Drr - 3));
        defWin18 = (team1Drr < 2) ? 0 : Math.floor(overs * (team1Drr - 2));
        defWin17 = (team1Drr < 1) ? 0 : Math.floor(overs * (team1Drr - 1));

        defLoss4 = getOvers('d', (fiScore + 1) / (team1Drr + 0.25));
        defLoss2 = getOvers('d', (fiScore + 1) / (team1Drr + 0.5));
        defLoss1 = getOvers('d', (fiScore + 1) / (team1Drr + 0.75));

        setChWin20("Score <b>" + (fiScore + 1) + "</b> or more runs in <span style='font-size:16px; color:red'>" + chWin20 + "</span> or less overs.");
        setChWin18("Score <b>" + (fiScore + 1) + "</b> or more runs in <span style='font-size:16px; color:red'>" + chWin18 + "</span> or less overs.");
        setChWin17("Score <b>" + (fiScore + 1) + "</b> or more runs in <span style='font-size:16px; color:red'>" + chWin17 + "</span> or less overs.");

        var chLoss4Text = (chLoss4 <= 0) ? "Minimum 4 points assured." : "Score <span style='font-size:16px; color:red'>" + chLoss4 + "</span> or more runs.";
        var chLoss2Text = (chLoss2 <= 0 && chLoss4 - 1 <= 0) ? "Minimum 2 points assured." : "Score <span style='font-size:16px; color:red'>" + chLoss2 + "-" + (chLoss4 - 1) + "</span> runs.";
        var chLoss1Text = (chLoss2 - 1 <= 0 && chLoss1 <= 0) ? "Minimum 1 point assured." : "Score <span style='font-size:16px; color:red'>" + chLoss1 + "-" + (chLoss2 - 1) + "</span> runs.";

        setChLoss4(chLoss4Text);
        setChLoss2(chLoss2Text);
        setChLoss1(chLoss1Text);


        var defWin20Text = (defWin20 == 0) ? "Score is too less to get 20 points." : "Restrict the opposition to <span style='font-size:16px; color:red'>" + defWin20 + "</span> or less runs.";
        var defWin18Text = (defWin18 == 0) ? "Score is too less to get 18 points." : "Restrict the opposition to <span style='font-size:16px; color:red'>" + (defWin20 + 1) + "-" + defWin18 + "</span> runs.";
        var defWin17Text = (defWin17 == 0) ? "Score is too less to get 17 points." : "Restrict the opposition to <span style='font-size:16px; color:red'>" + (defWin18 + 1) + "-" + defWin17 + "</span> runs.";

        setDefWin20(defWin20Text);
        setDefWin18(defWin18Text);
        setDefWin17(defWin17Text);

        setDefLoss4("Have the opposition bat <span style='font-size:16px; color:red'>" + defLoss4 + "</span> or more overs.");
        setDefLoss2("Have the opposition bat <span style='font-size:16px; color:red'>" + defLoss2 + "</span> or more overs.");
        setDefLoss1("Have the opposition bat <span style='font-size:16px; color:red'>" + defLoss1 + "</span> or more overs.");


        setLoading(false);




    };

    return (
       <>
        <Row className='mb-2'>
            <Col xs={12} md={{offset: 2, span:8}} >
               
                        <h2>Target Calculator</h2>
                        <Form>
                            <Row className='mb-2'>
                                <Col sm={6} md={3}>
                                    <Form.Group controlId="tca-total-overs">
                                        <Form.Label>Overs:</Form.Label>
                                        <Form.Control
                                            type="number"
                                            value={overs}
                                            onChange={(e) => setOvers(parseInt(e.target.value))}
                                            min={1}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={6} md={3}>
                                    <Form.Group controlId="tca-fi-score">
                                        <Form.Label>First Inning Score:</Form.Label>
                                        <Form.Control
                                            type="number"
                                            value={fiScore}
                                            onChange={(e) => setFiScore(parseInt(e.target.value))}
                                            min={1}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Button variant="primary" onClick={calculateTarget}>
                                Calculate
                            </Button>
                        </Form>
                        </Col>
        </Row>
                        {!loading && <>
                            <h2>Team Chasing</h2>
                            <Row>



                                <Col xs={12} md={6}>

                                    <Card className="mb-4">
                                        <Card.Header>      When Winning * </Card.Header>
                                        <Card.Body className='p-0'>

                                            <Table responsive striped bordered hover className='m-0'>

                                                <thead><tr><th>Points</th><th>Target</th></tr></thead>
                                                <tbody>
                                                    <tr><td>20</td><td dangerouslySetInnerHTML={{ __html: chWin20 }} /></tr>
                                                    <tr><td>18</td><td dangerouslySetInnerHTML={{ __html: chWin18 }} /></tr>
                                                    <tr><td>17</td><td dangerouslySetInnerHTML={{ __html: chWin17 }} /></tr>
                                                </tbody>
                                            </Table>
                                            <Card.Footer>
                                                <div style={{ color: '#d00', fontSize: '12px', paddingTop: '10px' }}>* Assuming the chasing team scored <span className='target-score'></span> runs. If they scored more, the numbers above may not be accurate.</div>
                                            </Card.Footer>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Card className="mb-4">
                                        <Card.Header>When Losing</Card.Header>
                                        <Card.Body className='p-0'>

                                            <Table responsive striped bordered hover className='m-0'>

                                                <thead><tr><th>Points</th><th>Target</th></tr></thead>
                                                <tbody>
                                                    <tr><td>4</td><td dangerouslySetInnerHTML={{ __html: chLoss4 }} /></tr>
                                                    <tr><td>2</td><td dangerouslySetInnerHTML={{ __html: chLoss2 }} /></tr>
                                                    <tr><td>1</td><td dangerouslySetInnerHTML={{ __html: chLoss1 }} /></tr>
                                                </tbody>
                                            </Table>
                                        </Card.Body>
                                    </Card>
                                </Col>

                            </Row>
                            <h2>Team Defending</h2>
                            <Row>
                                <Col xs={12} md={6}>
                                    <Card className="mb-4">
                                        <Card.Header>      When Winning * </Card.Header>
                                        <Card.Body className='p-0'>

                                            <Table responsive striped bordered hover className='m-0'>

                                                <thead><tr><th>Points</th><th>Target</th></tr></thead>
                                                <tbody>
                                                    <tr><td>20</td><td dangerouslySetInnerHTML={{ __html: defWin20 }} /></tr>
                                                    <tr><td>18</td><td dangerouslySetInnerHTML={{ __html: defWin18 }} /></tr>
                                                    <tr><td>17</td><td dangerouslySetInnerHTML={{ __html: defWin17 }} /></tr>
                                                </tbody>
                                            </Table>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Card className="mb-4">
                                        <Card.Header>When Losing</Card.Header>
                                        <Card.Body className='p-0'>
                                            <Table responsive striped bordered hover className='m-0'>

                                                <thead><tr><th>Points</th><th>Target</th></tr></thead>
                                                <tbody>
                                                    <tr><td>4</td><td dangerouslySetInnerHTML={{ __html: defLoss4 }} /></tr>
                                                    <tr><td>2</td><td dangerouslySetInnerHTML={{ __html: defLoss2 }} /></tr>
                                                    <tr><td>1</td><td dangerouslySetInnerHTML={{ __html: defLoss1 }} /></tr>
                                                </tbody>
                                            </Table>
                                        </Card.Body>
                                        <Card.Footer>
                                            <div style={{ color: '#d00', fontSize: '12px', paddingTop: '10px' }}>* Assuming the chasing team scored <span className='target-score'></span> runs. If they scored more, the numbers above may not be accurate.</div>
                                        </Card.Footer>
                                    </Card>
                                </Col>
                            </Row>

                        </>}
                        </>
         

    );
}

export default TargetCalculator;
